import Persona from 'persona';
export const makePersonaClientMaker = (Client)=>(param)=>{
        let { onError, onReady, onComplete, onCancel } = param;
        return {
            open (inquiryId, sessionToken) {
                const client = new Client({
                    inquiryId,
                    sessionToken: sessionToken || undefined,
                    onError,
                    onReady: ()=>{
                        onReady && onReady();
                        client.open();
                    },
                    onComplete,
                    onCancel
                });
            }
        };
    };
export const makePersonaClient = makePersonaClientMaker(Persona.Client);
